import { listOfCountries } from '@/data/selectOptions'

const countryCodeByKey = new Map<string, string>()

listOfCountries.forEach(country => {
  if (!country.value) return
  const code = String(country.value)
  countryCodeByKey.set(code.toLowerCase(), code)
  countryCodeByKey.set(country.name.trim().toLowerCase(), code)
})

const normalizeCountryToken = (value: string) => {
  const trimmed = value.trim()
  if (!trimmed) return ''
  return countryCodeByKey.get(trimmed.toLowerCase()) || trimmed
}

/** Accepts an ISO code, a country name, or a comma-separated mix of either. Unknown values are kept. */
export const normalizeCountryValue = <T extends string | null | undefined>(value: T): T => {
  if (typeof value !== 'string' || value === '') return value
  return value.split(',').map(part => normalizeCountryToken(part)).join(',') as T
}

export const normalizeCountryFields = (
  record: Record<string, any> | null | undefined,
  fields: string[]
) => {
  if (!record) return record
  const next = { ...record }
  fields.forEach(field => {
    if (typeof next[field] === 'string') {
      next[field] = normalizeCountryValue(next[field])
    }
  })
  return next
}

export const normalizeLoadedPersonalAboutYou = (aboutYou: Record<string, any> | null | undefined) => {
  if (!aboutYou) return aboutYou
  return {
    ...normalizeCountryFields(aboutYou, [
      'countryOfBirth',
      'countryOfCitizenship',
      'country',
      'previousCountry',
      'postCountry'
    ]),
    coBorrowerDetails: normalizeCountryFields(aboutYou.coBorrowerDetails, [
      'coBorrowerCountryOfBirth',
      'coBorrowerCountryOfCitizenship',
      'coBorrowerCountry',
      'coBorrowerPreviousCountry',
      'coBorrowerPostCountry'
    ])
  }
}

export const normalizeLoadedBusinessAboutYou = (aboutYou: Record<string, any> | null | undefined) => {
  return normalizeCountryFields(aboutYou, [
    'country',
    'postCountry',
    'previousCountry',
    'countryOfBirth',
    'countryOfCitizenship'
  ])
}

export const normalizeLoadedAboutYourBusiness = (aboutYourBusiness: Record<string, any> | null | undefined) => {
  if (!aboutYourBusiness) return aboutYourBusiness
  return {
    ...aboutYourBusiness,
    limitedCompany: normalizeCountryFields(aboutYourBusiness.limitedCompany, [
      'physicalCountry',
      'postalCountry',
      'registeredCountry'
    ])
  }
}
